import React from 'react';
import { ENABLED_MODULES } from '@/env';
import { adminRoute } from '@/modules/administration/routes';
import {
  AuthorizationError,
  NotFoundError,
  RouteErrorHandler,
} from '@/shared/components/route-error-handler';
import { createRoute } from '@tanstack/react-router';

export const contractsRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: 'contracts',
  wrapInSuspense: true,
  component: React.lazy(async () => await import('@/app/routes/Admin/Contracts')),
  beforeLoad: ({ context }) => {
    if (!context.auth.userIsAdmin()) {
      throw new AuthorizationError('User is not an admin');
    }
    if (!ENABLED_MODULES.includes('contracts')) {
      throw new NotFoundError('Contracts module is not available for this client');
    }
  },
  errorComponent: ({ error, reset }) => {
    return <RouteErrorHandler error={error} reset={reset} routeName="contracts" />;
  },
});
